
import { Component, Vue, Watch } from 'vue-property-decorator'
import FormInput from '@/components/forms/FormInput2.vue'
import FormInput2 from '@/components/forms/FormInput2.vue'
import { getIdentityFormFields } from '@/helpers/IdentityFormHelpers'
import { getIdentityPayload, IdentityFormData, PatchableIdentityFormData } from '@/helpers/IdentityHelpers'
import { mapGetters } from 'vuex'
import IdentityForm from '@/components/forms/IdentityForm.vue'
import store from '@/store/store'
import { splitFullName } from '@/helpers/StringHelpers'
import type { WithMeta } from '@/api/types/processedEntities'
import { environment } from '@/helpers/Environment'

@Component({
  components: { IdentityForm, FormInput2, FormInput },
  computed: mapGetters({
    identityFormConfigurations: 'Cart/identityFormConfigurations',
    identityWithMeta: 'Member/identityWithMeta',
  }),
})
export default class MyProfileRoute extends Vue {
  identityFormConfigurations: string[]
  identityFormData: IdentityFormData | null = null
  identityWithMeta: WithMeta<Identity>[]
  loading: boolean = false
  readonly readonlyFields = ['email', 'first_name', 'last_name']
  readonly deletableFields = new Set(['state'])

  // TODO: Remove these config options once we have confidence in this in production
  enabled: boolean = environment.config.my_account_pages?.my_profile ?? false

  @Watch('identityWithMeta', { immediate: true })
  updateIdentityFormData() {
    const identity = this.identityWithMeta[0]
    const [first, last] = splitFullName(identity.name)
    this.identityFormData = {
      ...identity.meta,
      first_name: first,
      last_name: last,
      email: identity.email,
    }
  }

  get identityFormFields() {
    return getIdentityFormFields(this.identityFormData!, this.identityFormConfigurations, {
      omit: ['email_confirm'],
      readOnlyFields: this.readonlyFields,
    })
  }

  updateIdentity() {
    this.loading = true
    const data: PatchableIdentityFormData = { ...this.identityFormData }

    for (const field of this.identityFormFields) {
      if (field.disabled && !field.readOnly && this.deletableFields.has(field.key)) {
        // The state field can become disabled if a country that has no states is selected, such as NZ.
        // In this scenario the field's value should be deleted.
        // Only a null value deletes the value with PATCH.
        data[field.key] = null
      }
    }

    const payload = getIdentityPayload(data)

    store.dispatch('Member/updateUser', payload).finally(() => {
      this.loading = false
    })
  }
}
